import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from '@wds/grid';
import { Tab, Tabs } from '@wds/tabs';
import { Box } from '@wds/box';
import { sanitizeString } from '@sm/utils';
import { Typography } from '@wds/typography';
import { List } from '@wds/list';
import { IconGear, IconUserFilled } from '@wds/icons';
import useStyles from '../styles';

export const AppDetailsInfo = ({ appDetails }) => {
  const { appDetailsTab } = useStyles();

  return (
    <Grid noBleeds>
      <Grid.Item>
        <Tabs fullWidth color="transparent">
          <Tab title="Description" selected>
            <Box className={appDetailsTab}>
              <div
                dangerouslySetInnerHTML={{
                  __html: sanitizeString(appDetails.fullDescription),
                }}
              />
            </Box>
          </Tab>
          <Tab title="Requirements" data-testid="AppDetailsInfo__AppDirectoryRequirementsTab">
            <Box className={appDetailsTab}>
              <If condition={appDetails.details.requirements}>
                <Box my={2}>
                  <Typography
                    variant="cardTitle"
                    component="h3"
                    weight="medium"
                    data-testid="AppDetailsInfo__AppDirectoryRequirements"
                  >
                    {`This app will require an additional ${appDetails.details.requirements.type} account:`}
                  </Typography>
                </Box>
                <List noRules>
                  <List.Item addOnLeft={<IconUserFilled color="light-muted" />}>
                    <a
                      href={`${appDetails.details.requirements.pricingUrl}en`}
                      target="_blank"
                      rel="noreferrer noopener"
                    >
                      <Typography className="wds-m-l-2" variant="link">
                        {appDetails.details.requirements.label}
                      </Typography>
                    </a>
                  </List.Item>
                </List>
                <If condition={appDetails.details.requirements.description}>
                  <p>{appDetails.details.requirements.description}</p>
                </If>
              </If>
              <If condition={appDetails.details.scopes}>
                <Box my={2}>
                  <Typography variant="cardTitle" component="h3">
                    This app will require access to:
                  </Typography>
                </Box>
                <List noRules>
                  {appDetails.details.scopes.map(scope => (
                    <List.Item key={scope} addOnLeft={<IconGear color="light-muted" />}>
                      <span>{scope}</span>
                    </List.Item>
                  ))}
                </List>
              </If>
            </Box>
          </Tab>
        </Tabs>
      </Grid.Item>
    </Grid>
  );
};

AppDetailsInfo.propTypes = {
  appDetails: PropTypes.shape({
    id: PropTypes.string,
    isIntegration: PropTypes.bool,
    name: PropTypes.string,
    tagline: PropTypes.string,
    fullDescription: PropTypes.string,
    logo: PropTypes.string,
    installed: PropTypes.bool,
    details: PropTypes.shape({
      publisher: PropTypes.string,
      featureList: PropTypes.arrayOf(PropTypes.string),
      googleAnalyticsTrackingId: PropTypes.string,
      supportEmail: PropTypes.string,
      supportPhoneNumber: PropTypes.string,
      supportUrl: PropTypes.string,
      requirements: PropTypes.arrayOf(PropTypes.string),
      screenshots: PropTypes.arrayOf(PropTypes.string),
      privacyPolicyUrl: PropTypes.string,
      termsOfUseUrl: PropTypes.string,
      blogUrl: PropTypes.string,
      youtubeUrl: PropTypes.string,
      websiteUrl: PropTypes.string,
      installUrl: PropTypes.string,
      upgradeRequired: PropTypes.bool,
      optionalUpgrade: PropTypes.bool,
      scopes: PropTypes.arrayOf(PropTypes.string),
      link: PropTypes.string,
      linkType: PropTypes.string,
    }),
  }).isRequired,
};

export default AppDetailsInfo;
